/**
 * Converts markdown text back to HTML for display in the editor
 * This is the reverse of convertHtmlToMarkdown
 * The main purpose is to convert newlines (\n) to <br /> tags
 * and restore basic formatting (bold, italic)
 */
export const convertMarkdownToHtml = (markdown: string): string => {
  if (!markdown) return "";

  let html = markdown
    // Bold: *text* → <strong>text</strong>
    .replace(/\*([^*]+)\*/g, "<strong>$1</strong>")
    // Italic: _text_ → <em>text</em>
    .replace(/_([^_]+)_/g, "<em>$1</em>")
    // Convert all newlines to <br /> tags
    // This handles both single and double newlines
    .replace(/\n/g, "<br />")
    .trim();

  return html;
};
